const getCheapestProviders = (quotes) => {
    // sort quotes receivedAmount
    // then take the first one, and if there are more that are equal to the first one, also take them
    const sortedQuotes = quotes.sort((a, b) => b.receivedAmount.value - a.receivedAmount.value);
    const cheapestProviders = sortedQuotes.filter((quote) => quote.receivedAmount.value === sortedQuotes[0].receivedAmount.value);
    return cheapestProviders.map((quote) => quote.provider.alias);
};
export default getCheapestProviders;
